import axios from "../config/axiosConfig";

export const getAllUsers = async (page = 1, limit = 10, searchQuery = "") => {
  try {
    const response = await axios.get("/users", {
      params: { page, limit, searchQuery },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await axios.delete(`/users/${id}`);
    return response.status;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (data) => {
  try {
    const response = await axios.patch(`/users/${data?.id}`, data);
    console.log(response);
    return response?.status;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (data) => {
  try {
    const response = await axios.post(`/users`, data);
    return response?.status;
  } catch (error) {
    throw error;
  }
};
